// src/pages/FAQ.jsx
import React, { useState } from 'react';

const FAQ = () => {
  const [openQuestion, setOpenQuestion] = useState(null);

  // Toggle question accordion
  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  // FAQ data
  const faqData = [
    {
      question: "Is TotsPal free to use?",
      answer: "Yes, TotsPal is free for all users. Parents can search for childcare options, providers can list their services, and job seekers can create profiles at no cost."
    },
    {
      question: "How does TotsPal verify childcare providers?",
      answer: "Providers can indicate whether they are licensed or not in their profiles. We recommend that parents verify credentials directly with providers and conduct their own due diligence before making childcare arrangements."
    },
    {
      question: "Can I list temporary or part-time childcare availability?",
      answer: "Absolutely! Childcare providers can list full-time, part-time, and drop-in spots with specific dates and times. This flexibility helps both providers fill temporary vacancies and parents find care for irregular schedules."
    },
    {
      question: "How do I contact a childcare provider or job seeker?",
      answer: "Once you find a provider or job seeker you're interested in, you can view their profile and use their preferred contact method (phone or email) to reach out directly. Communication happens outside the platform to give you flexibility in how you connect."
    },
    {
      question: "What types of childcare providers can I find on TotsPal?",
      answer: "TotsPal includes both licensed daycare centers and home-based childcare providers. You can filter your search based on type, location, age groups served, and many other criteria to find the right fit for your family."
    },
    {
      question: "How do I set up my profile as a childcare provider?",
      answer: "After registering as a provider, you'll be guided through a profile setup process where you can add details about your services, capacity, programs, location, and more. The more complete your profile, the more attractive it will be to parents looking for childcare."
    },
    {
      question: "Can I search for specific programs or activities?",
      answer: "Yes! Parents can search for providers offering specific educational programs like Montessori, Reggio Emilia, or play-based learning, as well as activities such as arts and crafts, outdoor play, music, and more."
    },
    {
      question: "How do I join the waitlist for a childcare provider?",
      answer: "When viewing a provider's profile, you can request to join their waitlist by clicking the 'Join Waitlist' button and providing information about your child and your childcare needs. The provider will then review your request and update you on your status."
    },
    {
      question: "Can I find backup childcare for emergencies?",
      answer: "Yes, you can search for providers who offer drop-in care for emergency or backup situations. Some providers specifically offer this service to help parents when their regular childcare arrangements fall through."
    },
    {
      question: "How do I create a job posting as a childcare provider?",
      answer: "Registered providers can create job postings by navigating to the 'Post Jobs' section from their dashboard. You can specify job details, requirements, schedule, and compensation to attract qualified caregivers."
    }
  ];

  return (
    <div className="faq-page">
      <h1>Frequently Asked Questions</h1>
      <p className="faq-intro">Find answers to common questions about using TotsPal.</p>
      
      <div className="accordion">
        {faqData.map((faq, index) => (
          <div className="accordion-item" key={index}>
            <button 
              className="accordion-header"
              onClick={() => toggleQuestion(index)}
              aria-expanded={openQuestion === index}
            >
              {faq.question}
              <span className="accordion-icon">{openQuestion === index ? '−' : '+'}</span>
            </button>
            
            {openQuestion === index && (
              <div className="accordion-content">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
      
      <div className="additional-help">
        <h2>Need More Help?</h2>
        <p>Can't find the answer you're looking for? Contact our support team at support@totspal.com</p>
      </div>
    </div>
  );
};

export default FAQ;